import { Box, Heading } from "@chakra-ui/react";
import ReactGA from "react-ga4";

function Privacy(){
    ReactGA.send({
    hitType: "pageview",
    page: "/privacypolicy",
    title: "Privacy Policy",
  });
  return (
    <Box
        bgColor='white'
        overflow='hidden'
        minH='500px'
        borderRadius='16px'
        my='40px'
        style={{ opacity: 0.9 }}
      >
        <Heading
          alignItems='center'
          justifyContent='space-between'
          display='flex'
          p='16px'
          bgColor='primary'
          fontSize='4xl'
        >
          PRIVACY POliCY
        </Heading>

        <div style={{ 
        maxWidth: '1200px', 
        padding: '32px', 
        backgroundColor: 'white', 
      }}>
        <div style={{ marginTop: '8px' }}>
            <p style={{ 
              fontSize: '14px', 
              color: '#6B7280', 
              marginBottom: '24px' 
            }}>
                <strong>Effective Date: </strong>July 22, 2025
            </p>
            
            <p style={{ marginBottom: '24px' }}>
                Welcome to <strong>leaderbored.gg</strong>, operated by <strong>Cadre Creative Labs OPC</strong> ("we," "our," or "us"). We respect your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, and share your information when you visit our website.
            </p>

            <section style={{ marginBottom: '32px' }}>
                <h2 style={{ 
                  fontSize: '32px', 
                  fontWeight: '600', 
                  color: '#1F2937', 
                  marginBottom: '16px' 
                }}>1. Information We Collect</h2>
                
                <h3 style={{ 
                  fontSize: '24px', 
                  fontWeight: '600', 
                  color: '#1F2937', 
                  marginBottom: '12px' 
                }}>Information You Provide</h3>
                <ul style={{ listStyleType: 'disc', paddingLeft: '24px', marginBottom: '20px' }}>
                    <li style={{ marginBottom: '8px' }}>When you register, participate in leaderboards, contests, or contact us, we may collect your name, email, and game activity.</li>
                </ul>

                <h3 style={{ 
                  fontSize: '24px', 
                  fontWeight: '600', 
                  color: '#1F2937', 
                  marginBottom: '12px' 
                }}>Information We Collect Automatically</h3>
                <ul style={{ listStyleType: 'disc', paddingLeft: '24px', marginBottom: '12px' }}>
                    <li style={{ marginBottom: '8px' }}>We automatically collect data about your device, browser, visited pages, scores, and time spent on the site using:</li>
                </ul>
                <ul style={{ listStyleType: 'disc', paddingLeft: '48px', marginBottom: '20px' }}>
                    <li style={{ marginBottom: '8px' }}><strong>Google Analytics</strong> for usage tracking</li>
                    <li style={{ marginBottom: '8px' }}><strong>Google AdSense</strong> and <strong>Playfab</strong> for advertising and rewards</li>
                    <li style={{ marginBottom: '8px' }}>Cookies and similar technologies</li>
                </ul>

                <h3 style={{ 
                  fontSize: '24px', 
                  fontWeight: '600', 
                  color: '#1F2937', 
                  marginBottom: '12px' 
                }}>Third-Party Services</h3>
                <ul style={{ listStyleType: 'disc', paddingLeft: '24px' }}>
                    <li style={{ marginBottom: '8px' }}>If you log in or interact through third-party services, we may receive profile information (e.g., name, email).</li>
                </ul>
            </section>

            <section style={{ marginBottom: '32px' }}>
                <h2 style={{ 
                  fontSize: '32px', 
                  fontWeight: '600', 
                  color: '#1F2937', 
                  marginBottom: '16px' 
                }}>2. How We Use Your Information</h2>
                <p style={{ marginBottom: '12px' }}>We use your information to:</p>
                <ul style={{ listStyleType: 'disc', paddingLeft: '24px' }}>
                    <li style={{ marginBottom: '8px' }}>Operate and improve leaderbored.gg</li>
                    <li style={{ marginBottom: '8px' }}>Track high scores and manage leaderboards</li>
                    <li style={{ marginBottom: '8px' }}>Serve relevant ads and promotions</li>
                    <li style={{ marginBottom: '8px' }}>Analyze website traffic and user engagement</li>
                    <li style={{ marginBottom: '8px' }}>Respond to inquiries and provide support</li>
                </ul>
            </section>

            <section style={{ marginBottom: '32px' }}>
                <h2 style={{ 
                  fontSize: '32px', 
                  fontWeight: '600', 
                  color: '#1F2937', 
                  marginBottom: '16px' 
                }}>3. Data Sharing</h2>
                <ul style={{ listStyleType: 'disc', paddingLeft: '24px' }}>
                    <li style={{ marginBottom: '8px' }}>We <strong>do not sell your data</strong>.</li>
                    <li style={{ marginBottom: '12px' }}>We may share data with:</li>
                </ul>
                <ul style={{ listStyleType: 'disc', paddingLeft: '48px' }}>
                    <li style={{ marginBottom: '8px' }}><strong>Google Analytics</strong>, <strong>Google AdSense</strong>, and <strong>Playab</strong> for services and ads</li>
                    <li style={{ marginBottom: '8px' }}>Legal authorities, if required by Philippine law</li>
                </ul>
            </section>

            <section style={{ marginBottom: '32px' }}>
                <h2 style={{ 
                  fontSize: '32px', 
                  fontWeight: '600', 
                  color: '#1F2937', 
                  marginBottom: '16px' 
                }}>4. Cookies</h2>
                <p>
                    We use cookies to enhance your browsing experience and serve ads. You can control or delete cookies in your browser settings.
                </p>
            </section>

            <section style={{ marginBottom: '32px' }}>
                <h2 style={{ 
                  fontSize: '32px', 
                  fontWeight: '600', 
                  color: '#1F2937', 
                  marginBottom: '16px' 
                }}>5. Your Rights</h2>
                <p style={{ marginBottom: '12px' }}>You have the right to:</p>
                <ul style={{ listStyleType: 'disc', paddingLeft: '24px', marginBottom: '16px' }}>
                    <li style={{ marginBottom: '8px' }}>Access, update, or delete your personal information</li>
                    <li style={{ marginBottom: '8px' }}>Opt-out of marketing emails</li>
                    <li style={{ marginBottom: '8px' }}>Request account deletion</li>
                </ul>
                <p>
                    To exercise your rights, contact us at{" "}
                    <a 
                        href="mailto:support@cadrecreativelabs.com" 
                        style={{ 
                          color: '#2563EB', 
                          textDecoration: 'underline', 
                          fontWeight: '500' 
                        }}
                    >
                        support@cadrecreativelabs.com
                    </a>.
                </p>
            </section>

            <section style={{ marginBottom: '32px' }}>
                <h2 style={{ 
                  fontSize: '32px', 
                  fontWeight: '600', 
                  color: '#1F2937', 
                  marginBottom: '16px' 
                }}>6. Children's Privacy</h2>
                <p>
                    Leaderbored.gg is intended for users aged <strong>13 and above</strong>. We do not knowingly collect data from anyone under 13 years old.
                </p>
            </section>

            <section style={{ marginBottom: '32px' }}>
                <h2 style={{ 
                  fontSize: '32px', 
                  fontWeight: '600', 
                  color: '#1F2937', 
                  marginBottom: '16px' 
                }}>7. Data Security</h2>
                <p>
                    We apply reasonable safeguards to protect your data but cannot guarantee absolute security.
                </p>
            </section>

            <section style={{ marginBottom: '32px' }}>
                <h2 style={{ 
                  fontSize: '32px', 
                  fontWeight: '600', 
                  color: '#1F2937', 
                  marginBottom: '16px' 
                }}>8. Changes to This Policy</h2>
                <p>
                    We may update this Privacy Policy. Any changes will be posted on this page with a new effective date.
                </p>
            </section>

            <section style={{ marginBottom: '32px' }}>
                <h2 style={{ 
                  fontSize: '32px', 
                  fontWeight: '600', 
                  color: '#1F2937', 
                  marginBottom: '16px' 
                }}>9. Contact Us</h2>
                <p>
                    If you have questions about this policy, contact us at:{" "}
                    <a 
                        href="mailto:support@cadrecreativelabs.com" 
                        style={{ 
                          color: '#2563EB', 
                          textDecoration: 'underline', 
                          fontWeight: '500' 
                        }}
                    >
                        support@cadrecreativelabs.com
                    </a>
                </p>
            </section>
        </div>
      </div>

    </Box>
  )
}
export default Privacy;